import { Injectable } from '@angular/core';
import { ArtistLinkService } from './ArtistLinkService';
import { AlbumLinkService } from './AlbumLinkService';
import { YouTubeLinkService } from './YouTubeLinkService';

@Injectable()
export class ParagraphTextRenderingService {

  constructor(
    private artistLinkService: ArtistLinkService,
    private albumLinkService: AlbumLinkService,
    private youTubeLinkService: YouTubeLinkService) { }

  getRenderedText(text: string, artistId: string): string {
    if (!text) {
      return text;
    }
    let updatedText = this.artistLinkService.updateTextWithArtistLinks(text);
    updatedText = this.albumLinkService.updateTextWithAlbumLinks(updatedText, artistId);
    updatedText = this.youTubeLinkService.updateTextWithYouTubeLinks(updatedText);
    if (!updatedText.startsWith("<p>")) {
        // avoids the need for <p> to be manually added to the start of every 
        // artist/album review in my music collection database. i only need to add
        // a <p> when working with multiple paragraphs, which isn't that common.
        updatedText = "<p>" + updatedText;
    }
    return updatedText;
  }

}
